import { format, parse } from "date-fns"
import { DateUtils } from "react-day-picker"

export function parseDate(str, format, locale) {
  const parsed = parse(str, format, new Date(), { locale })
  if (DateUtils.isDate(parsed)) {
    return parsed
  }
  return undefined
}

export function formatDate(date, fmt, locale) {
  return format(date, fmt, { locale })
}
